import { EmptyReportOverlay } from '@report/components';
import { useGetSearchExamQSetUsageRecordsQuery } from '@report/graphql';
import { NoRowsOverlay } from '@shared/components';
import { dayjs } from '@shared/utils';
import { useMemo } from 'react';

import { QSetUsageReportDataGrid } from '../../components';
import { useQSetUsageReportSearchParams } from '../../hooks';

import { mapQSetUsageReportItem } from './utils';

export default function QSetUsageReportList() {
  const [
    { examStartDate, examEndDate, examCourseId, page, pageSize },
    { changePageNumber, changePageSize },
  ] = useQSetUsageReportSearchParams();

  const isSearchEmpty = !examStartDate || !examEndDate || !examCourseId;

  const { data: qSetUsageData, loading: isLoading } = useGetSearchExamQSetUsageRecordsQuery({
    variables: {
      searchExamQSetUsageRecordsInput: {
        paging: {
          pageSize,
          currentPage: page,
        },
        filter: {
          startedAt: (examStartDate ? dayjs(examStartDate).startOf('day').toDate() : null) as Date,
          endedAt: (examEndDate ? dayjs(examEndDate).endOf('day').toDate() : null) as Date,
          examCourseId: examCourseId as string,
        },
      },
    },
    skip: isSearchEmpty,
  });

  const rows = useMemo(
    () =>
      qSetUsageData?.reportSearchExamQSetUsageRecords?.records.map(mapQSetUsageReportItem) ?? [],
    [qSetUsageData?.reportSearchExamQSetUsageRecords?.records],
  );

  const total = qSetUsageData?.reportSearchExamQSetUsageRecords?.total ?? 0;

  const handlePageChange = (newPage: number) => {
    changePageNumber(newPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    changePageSize(newPageSize);
  };

  return (
    <QSetUsageReportDataGrid
      rows={rows}
      loading={isLoading}
      hideFooter={isLoading || total === 0}
      slotProps={{
        footer: {
          total,
          pagination: {
            count: total,
            page: page,
            rowsPerPage: pageSize,
            onPageChange: (_event, page) => {
              handlePageChange(page);
            },
            onRowsPerPageChange: (event) => {
              const pageSize = parseInt(event.target.value);
              return handlePageSizeChange(pageSize);
            },
          },
        },
      }}
      slots={{
        noRowsOverlay: isSearchEmpty ? EmptyReportOverlay : NoRowsOverlay,
      }}
    />
  );
}
